<div class="hmd-btn form-btn">
  <template v-if="isEdit">
  <hmd-empty-link  @click="showEditModal">编辑</hmd-empty-link>
  </template>
  <template v-else>
    <slot name="addBrand" :showCreateModal="showCreateModal">
      <a-button  type="primary" @click="showCreateModal">新建</a-button>
    </slot>
  </template>

  <a-modal
    v-model:visible="visible"
    :confirm-loading="createLoading || editLoading"
    :keyboard="false"
    :centered="true"
    :mask-closable="false"
    destroyOnClose
    :zIndex="1200"
    @ok="submit"
    @cancel="closeModal"
  >
    <template #title>
      <template v-if="isEdit">编辑品牌</template>
      <template v-else>
        <span>新建品牌</span>
        <small>品牌编号将自动生成</small>
      </template>
    </template>
    <a-skeleton :loading="detailLoading" active>
      <a-form layout="vertical" :model="formRef" :rules="formRules" >
	  	<a-form-item label="品牌名称" name="name">
        <a-input
        v-model:value.trim="formRef.name"
        placeholder="请输入品牌名称"
        :maxlength="20"
        >
          <template #suffix>
            <span class="text-grey">{{ formRef.name.length }}/20</span>
          </template>
        </a-input>
		  <!-- <a-select
        v-model:value="formRef.name"
			  placeholder="请选择或输入品牌名称"
			  allow-clear
			  :filter-option="false"
			  :not-found-content="fetching ? undefined : null"
			  show-search
			  @search="handleSearch"
			  @blur="blurFn"
			  style="width:100%;"
			  @change="handleChange"
			>
			<a-spin v-if="fetching" slot="notFoundContent" size="small" />
			  <a-select-option
				v-for="item in data"
				:key="item.name"
				:title="item.name"
				:value="item.name"
			  >
				{{ item.name }}
			  </a-select-option>
			</a-select> -->
		</a-form-item>
        <a-form-item label="英文名称" name="enName">
          <a-input
            v-model:value.trim="formRef.enName"
            placeholder="请输入品牌的英文全称"
            :maxlength="40"
          >
            <template #suffix>
              <span class="text-grey">{{ formRef.enName.length }}/40</span>
            </template>
          </a-input>
        </a-form-item>

        <a-form-item label="所属分类" name="materialCategoryId">
          <material-category-select
            v-model:value="formRef.materialCategoryId"
            :multiple="true"
            :isRelative="isRelative"
          ></material-category-select>
        </a-form-item>

        <a-form-item label="备注说明" name="remark">
          <a-textarea
            v-model:value="formRef.remark"
            placeholder="请输入说明，最多200字"
            :rows="4"
            :maxlength="200"
            show-count
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-skeleton>
  </a-modal>
</div>
